export default __webpack_public_path__ + "0c7396463e642c7db18c0bbd0c964f4a.png";